export enum EnumMotivoRejeicao {
    BloqueioJudicialSaldoInsuficiente = 76,
    ContaCorrenteNaoCadastrada = 100,
    TransacaoInvalidaJaCadastrada = 112,
    AlteracaoInvalidaCompromissoLiberadoParaPagamento = 114,
    ExclusaoInvalidaCompromissoLiberadoParaPagamento = 119,
    CompromissoComPagamentoJaEfetuado = 130,
    FornecedorNaoCadastrado = 132,
    CompromissoNaoCadastrado = 139,
    AutorizacaoInvalidaInformarValorJurosMulta = 145,
    FaltaRedigitacaoCompromissos = 148,
    AgenciaOuContaInvalida = 157,
    CobAgenciaDebitoAgenciaPagamento = 195,
    CobDataPagamentoDataVencimento = 196,
    DataPagamentoFeriadoAgenciaPagamentoOuDebito = 197,
    CompromissoJaDebitadoCliente = 198,
    NomeEnderecoFornecedorObrigatorio = 200,
    CodigoFornecedorDeveSerNumerico = 201,
    CodigoFornecedorDigitoInvalido = 202,
    CpfCnpjDeveSerNumerico = 203,
    CpfCnpjDivergenteOuDigitoInvalido = 204,
    BancoCreditoDeveSerNumerico = 206,
    AgenciaCreditoNaoNumerica = 207,
    BancoCreditoNaoCadastrado = 210,
    VolumeJaProcessadoDadosDuplicados = 213,
    CobDataPagamentoInvalida = 216,
    CompromissoBloqueadoPorInsuficienciaSaldo = 217,
    AutorizacaoViaArquivoNaoPermitido = 240,
    DataVencimentoOuValorInvalida = 250,
    DataVencimentoInvalida = 251,
    TipoPagamentoInvalido = 252,
    DataPagamentoInvalidaOuExcedeuDataLimite = 253,
    BancoPortadorTituloDeveSerNumerico = 254,
    AgenciaPagamentoInvalida = 255,
    TipoDocumentoCompromissoNaoCadastrado = 258,
    MoedaNaoCadastrada = 259,
    DataPagamentoMenorOuIgualDataHoje = 260,
    BancoPortadorTituloNaoCadastrado = 261,
    AgenciaPagamentoNaoCadastrada = 262,
    DadosIncompletosParaPagamento = 264,
    DadosIncompletosParaPagamentoComDoc = 265,
    PagamentoCcFaltandoDados = 266,
    CompromissoVersusAgenciaPagamentoIncompleto = 269,
    CompromissoJaAutorizadoOuBloqueado = 271,
    IspbPspPagadorInvalidoOuInexistente = 288,
    FormaIniciacaoInvalida = 290,
    ChavePagamentoPixNaoInformada = 293,
    ChavePagamentoPixInvalida = 295,
    InclusaoNaoPermitidaCategoriaContaSalario = 299,
    DataInvalida = 303,
    MovimentoSemHeaderAgenciaContaDiferente = 304,
    NumeroDocumentoCompromissoInvalido = 312,
    CompromissoJaCadastrado = 313,
    CamaraCompensacaoInvalida = 314,
    ValorAbatimentoInvalido = 315,
    ValorJurosMultaInvalido = 316,
    ContaCorrenteNaoNumerica = 317,
    CodigoInstrucaoInvalido = 323,
    AgenciaClienteDiferenteRegistroHeader = 324,
    FaltaRegistroNumericoXxxx = 325,
    RegistroForaOrdem = 326,
    NumericoRegistroDeveSerNumerico = 327,
    ClienteDifereEmRelacaoInformado = 328,
    ValorAutorizadoInvalido = 331,
    CompromissoInvalido = 332,
    CompromissoNaoPodeSerBloqueado = 333,
    CompromissoNaoPodeSerDesbloqueado = 334,
    CodigoAlegacaoFinalidadeInvalido = 335,
    DescricaoAlegacaoInvalida = 336,
    IdentificacaoClienteInvalida = 337,
    ValorAutorizadoNaoNumerico = 347,
    ContaCreditoInvalida = 370,
    AgenciaCreditoInvalida = 371,
    AgenciaContaCorrenteInvalidaTecban = 375,
    BancoPortadorInvalido = 378,
    BancoDestinoInvalido = 379,
    CompromissoDuplicado = 382,
    LinhaDigitavelInvalida = 536,
    RegistroRejeitadoCriticaPrevia = 537,
    DataInvalidaTipoPagamentoChq = 538,
    FornecedorNaoTitularContaDestino = 598,
    DigitoCodigoBarrasInvalido = 606,
    ContaInvestimentoOutraTitularidade = 632,
    ContaDestinoNaoContaInvestimento = 633,
    ContaDestinoNaoEContaDeInvestimento = 634,
    NaoPermitidoValorAcimaLimiteDiario = 636,
    TipoDocumentoIgualDocParaCci = 639,
    AgenciaOuContaInvestimentoInvalida = 640,
    InclusaoInvalidaParaCab = 650,
    TedAposHorarioLimite = 651,
    TedInferiorValorMinimo = 654,
    BancoNaoOperante = 782,
    RegistroNaoEncontradoSpb = 786,
    ClienteNaoCreditaCm = 813,
    BancoDestinoInvalidoParaTed = 860,
    ContaBiNaoAceitaFavorecidoPf = 875,
    FavorecidoDeveSerDiferenteInstituicaoFinanceiraBi = 876,
    ContasOrigemDestinoNaoSaoIguais = 882,
    ContaDestinoNaoPertenceTitularBbi = 883,
    FatorVencimentoCodigoBarrasInvalido = 884,
    ContaTipoMarca76 = 885,
    ValorParcelaInvalidoPlataformaCobranca = 886,
    ValorBoletoInvalidoPlataformaCobranca = 887,
    TituloNaoEncontradoBaseDados = 888,
    TituloBloqueadoBase = 889,
    SistemaContingenciaTituloValorMaiorReferencia = 890,
    SistemaContingenciaTituloVencido = 891,
    SistemaContingenciaTituloIndexado = 892,
    BeneficiarioDivergentePlataformaBoletos = 893,
    LimitePagamentosParciaisExcedidos = 894,
    CompromissoPagoOuBoletoLiquidadoOuBaixado = 895,
    ManutencaoNaoPermitidaBoletoEmAnalise = 896,
    BaseBoletosPagamentosIndisponivel = 897,
    PixNaoEfetivado = 910,
    TransacaoInterrompidaErroPspRecebedor = 915,
    ContaTransacionalEncerradaPspRecebedor = 916,
    TipoIncorretoContaTransacionalEspecificada = 917,
    TipoTransacaoNaoSuportadoContaTransacional = 918,
    CpfCnpjUsuarioRecebedorIncorreto = 919,
    OrdemRejeitadaPspRecebedor = 920,
    ChaveNaoCadastradaDict = 921,
}
